import { render, staticRenderFns } from "./TrinityRingsSpinner.vue?vue&type=template&id=65918846&scoped=true"
import script from "./TrinityRingsSpinner.vue?vue&type=script&lang=js"
export * from "./TrinityRingsSpinner.vue?vue&type=script&lang=js"
import style0 from "./TrinityRingsSpinner.vue?vue&type=style&index=0&id=65918846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65918846",
  null
  
)

export default component.exports